import { configureStore } from '@reduxjs/toolkit'
import appsReducer from './appsSlice'
import requestReducer from './requestSlice'
import activityReducer from './activitySlice'
import statusReducer from './statusSlice'
import bugReportsReducer from './bugReportsSlice'
import authReducer from './authSlice'
import chatReducer from './chatSlice'
import editorsReducer from './editorsSlice'
import docsReducer from './docsSlice'

export const store = configureStore({
  reducer: {
    apps: appsReducer,
    request: requestReducer,
    activity: activityReducer,
    status: statusReducer,
    bugReports: bugReportsReducer,
    auth: authReducer,
    chats: chatReducer,
    editors: editorsReducer,
    docs: docsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
